import { useCallback, useEffect, useState } from 'react';

import { useServerTime } from './use-server-time';

export const useTimer = () => {
  const { data } = useServerTime();
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (data) {
      const now = new Date().getTime();
      setOffset(now - new Date(data).getTime());
    }
  }, [data]);

  const getTimeDelta = useCallback(
    (timestamp?: number | Date) => {
      if (!timestamp) {
        return 0;
      }
      if (typeof timestamp !== 'number') {
        timestamp = timestamp.getTime();
      }

      return timestamp - offset;
    },
    [offset]
  );

  return {
    offset,
    getTimeDelta,
  };
};
